import { isNil, reduce } from 'lodash'

/**
 * Dig object value using a flat key
 * @param {object} obj - Object to dig
 * @param {string} flatKey - Flat key
 * @param {boolean} digArray - Dig arrays
 * @return {any} - Object flat key value
 */
// eslint-disable-next-line import/prefer-default-export
export const dig = (obj, flatKey, digArray = false) => {
	const keys = flatKey.split('.')
	let cursor = obj
	do {
		if (digArray && Array.isArray(cursor) && keys.length) {
			return cursor.map(item => dig(item, keys.join('.'))).filter(item => !isNil(item))
		}

		const key = keys.shift()
		if (typeof cursor[key] === 'undefined' || cursor[key] === null) { return null }
		cursor = cursor[key]
	} while (keys.length)

	return cursor
}

/**
 * Ensure array
 * @param {*} arr - Array or element to ensure as array
 */
export const ensureArray = (arr) => {
	if (typeof arr === 'undefined' || arr === null) { return [] }
	return Array.isArray(arr) ? arr : [arr]
}
/**
 * Flatten object (obj.a.b ->obj[a.b])
 * @param {object} obj - Object to flatten
 * @param {string} prefix - Flat key prefix
 * @param {object} options - Options
 */
export const flattenObject = (obj, prefix = '', {
	removeUndefined = false,
	removeNull = false,
} = {}) => {
	if (typeof obj !== 'object') { return {} }

	return reduce(obj, (acc, value, key) => {
		const escapedKey = typeof key === 'string' ? key.replace(/\./g, '{{DOT}}') : key
		const current = prefix === '' ? escapedKey : `${prefix}.${escapedKey}`
		if (typeof value === 'object'
			&& value !== null
			&& !(value instanceof Date)
			&& Object.keys(value).length) {
			return {
				...acc,
				...flattenObject(value, current, {
					removeUndefined,
					removeNull,
					instance: this,
				}),
			}
		}

		if (removeUndefined && typeof value === 'undefined') {
			return { ...acc }
		}
		if (removeNull && value === null) {
			return { ...acc }
		}
		return { ...acc, [current]: value }
	}, {})
}

/**
 * Create an array with a range
 * @param {array} from - Start number (inclusive)
 * @param {array} to - End number (exclusive)
 */
export const range = (from, to) => Array.from({ length: to - from }, (_, i) => i + from)

/**
 * Clear empty array or object fields
 * @param {object|arra} - Object or array to clear
 */
export const clearEmptyFields = obj => Object.keys(obj).reduce((acc, key) => {
	const value = obj[key]
	if (value && value !== '') {
		acc[key] = value
	}
	return acc
}, {})
